/** @module Enums */ /** typedoc */


export enum SessionFlagsEnum {
    isEmailConfirmed = 'isEmailConfirmed',
    isFreeUser = 'isFreeUser',
    canCancel = 'canCancel',
    isCanceled = 'isCanceled',
    hasMastered = 'hasMastered',
    hasApprovedReleases = 'hasApprovedReleases',
    hasPromoted = 'hasPromoted',
    hasShared = 'hasShared',
    hasExpiringReleases = 'hasExpiringReleases',
    hasExpiredReleases = 'hasExpiredReleases',
    isReferred = 'isReferred',
    hasAlbums = 'hasAlbums',
    hasUnlimitedMastering = 'hasUnlimitedMastering',
    hasAdvancedMastering = 'hasAdvancedMastering',
}
